import BalconySvg from "@assets/images/svg/balcony.svg";
import React from "react";
import { View } from "react-native";

export interface BalconyIconProps {
  size?: number;
  color?: string;
}

export function BalconyIcon({
  size = 24,
  color = "#4D4D4D",
}: BalconyIconProps) {
  return (
    <View
      style={{
        width: size,
        height: size,
        justifyContent: "center",
        alignItems: "center",
      }}
    >
      <BalconySvg width={size} height={size} color={color} />
    </View>
  );
}

export default BalconyIcon;
